import styled from "styled-components";
import { Button } from "../../button";
export const StyledButton = styled(Button) `
  box-sizing: border-box;

  :focus {
    ${({ disabled }) => (disabled ? "outline: none;" : "")}
  }

  & svg {
    width: 1.25rem;
    ${({ theme }) => `fill: rgba(${theme.colors.transparentBlack}, 1);`}
  }

  &:disabled {
    & svg {
      ${({ theme }) => `fill: rgba(${theme.colors.transparentBlack}, 0.20);`}
    }
  }
`;
